export const DELETE_PACKAGE_ENTRY = "DELETE_PACKAGE_ENTRY";
export const CLEAR_CART = "CLEAR_CART";
export const BLOCK_SCREEN = "BLOCK_SCREEN";
export const UNBLOCK_SCREEN = "UNBLOCK_SCREEN";
export const SET_PACKAGE_ENTRIES = "SET_PACKAGE_ENTRIES";
